import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * The selected category ids. A server-rendered mount passes a JSON array as a string; a Vue host
   * binds an array. The model is an array in both modes; under `single` it holds at most one id,
   * and a value carrying several keeps the first.
   *
   * @type {Array|String}
   */
  modelValue: {
    type: [Array, String],
    default: undefined,
  },
  /**
   * The categories offered, as `[{ id, name, group }]` rows. A server-rendered mount passes them
   * as a JSON string. `group` is optional and names the section header a row renders under. Rows
   * without one are loose options: they render as a headerless block above every group, in their
   * authored order, wherever they sit in the array.
   *
   * @type {Array|String}
   */
  items: {
    type: [Array, String],
    default: () => [],
  },
  /**
   * Form field name each selected id is submitted under — one entry per id, the way a native
   * `<select multiple>` submits. Under `single` that is one entry.
   */
  name: {
    type: String,
    default: "categories[]",
  },
  /**
   * Offer one category at a time: a pick replaces the current one and closes the menu, and rows
   * render without checkboxes. Off, the picker is a checkbox multi-select that stays open.
   *
   * @type {Boolean|String}
   */
  single: booleanAttribute(),
  /** The activator label — the category group's name ("Type"). Per mount, so a prop. */
  label: {
    type: String,
    required: true,
  },
  prependIcon: {
    type: String,
    default: undefined,
  },
  appendIcon: {
    type: String,
    default: "popup-arrow-filled",
  },
  /** @type {Boolean|String} */
  hidePointer: booleanAttribute(),
  /** @type {Boolean|String} */
  open: booleanAttribute(),
  location: {
    type: String,
    default: undefined,
  },
  /** @type {Boolean|String} */
  nonClearable: booleanAttribute(),
});
